const nativeFetch = window.fetch.bind(window);

function currentPeriod() {
  const value = Number(localStorage.getItem("competenceo-active-period-v1"));
  return value === 2 || value === 3 ? value : 1;
}

function applyPeriodToSelect(period: number) {
  const label = document.querySelector<HTMLElement>(".period-select");
  const select = label?.querySelector<HTMLSelectElement>("select");
  if (!label || !select) return false;
  label.dataset.period = String(period);
  if (Number(select.value) !== period) {
    select.value = String(period);
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }
  return true;
}

async function savePeriod(period: number) {
  try {
    await nativeFetch("/api/qcm-extra/current-period", {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ period }),
    });
  } catch { /* le réglage local reste utilisable hors ligne */ }
}

async function hydratePeriod() {
  try {
    const response = await nativeFetch("/api/qcm-extra/current-period", { credentials: "include" });
    if (!response.ok) return;
    const body = await response.json();
    const remote = Number(body.period);
    if (remote === 1 || remote === 2 || remote === 3) {
      localStorage.setItem("competenceo-active-period-v1", String(remote));
      applyPeriodToSelect(remote);
    } else {
      await savePeriod(currentPeriod());
    }
  } catch { /* hors ligne */ }
}

window.fetch = async function competenceoFetch(input: RequestInfo | URL, init?: RequestInit) {
  const response = await nativeFetch(input, init);
  const url = typeof input === "string" ? input : input instanceof URL ? input.toString() : input.url;
  const method = String(init?.method ?? (input instanceof Request ? input.method : "GET")).toUpperCase();

  if (response.ok && method === "POST" && url.includes("/api/qcm/admin/sessions")) {
    try {
      const body = await response.clone().json();
      const sessionId = body?.session?.id;
      if (sessionId) {
        await nativeFetch("/api/qcm-extra/session-period", {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sessionId, period: currentPeriod() }),
        });
      }
    } catch { /* le QCM reste créé même si la métadonnée de période échoue */ }
  }

  if (response.ok && method === "GET" && url.includes("/api/qcm/student/scores")) {
    try {
      const original = await response.clone().json();
      const query = url.includes("?") ? url.slice(url.indexOf("?")) : "";
      const periodResponse = await nativeFetch(`/api/qcm-extra/student-periods${query}`, { credentials: "include" });
      if (!periodResponse.ok) return response;
      const periods = (await periodResponse.json()).periods ?? {};
      const scores = Array.isArray(original.scores)
        ? original.scores.map((score: any) => ({ ...score, period: Number(periods[score.sessionId] ?? 1) }))
        : [];
      return new Response(JSON.stringify({ ...original, scores }), {
        status: response.status,
        statusText: response.statusText,
        headers: { "Content-Type": "application/json; charset=utf-8", "Cache-Control": "no-store" },
      });
    } catch { return response; }
  }

  return response;
};

document.addEventListener("change", (event) => {
  const target = event.target;
  if (!(target instanceof HTMLSelectElement) || !target.closest(".period-select")) return;
  const period = Number(target.value);
  if (period !== 1 && period !== 2 && period !== 3) return;
  localStorage.setItem("competenceo-active-period-v1", String(period));
  const label = target.closest<HTMLElement>(".period-select");
  if (label) label.dataset.period = String(period);
  void savePeriod(period);
});

let historySyncPending = false;
async function decorateQcmHistory() {
  if (historySyncPending || !window.location.pathname.startsWith("/qcm-admin")) return;
  const cards = [...document.querySelectorAll<HTMLElement>(".qcm-history-card")];
  if (!cards.length) return;
  historySyncPending = true;
  try {
    const [historyResponse, periodResponse] = await Promise.all([
      nativeFetch("/api/qcm/admin/history", { credentials: "include" }),
      nativeFetch("/api/qcm-extra/history-periods", { credentials: "include" }),
    ]);
    if (!historyResponse.ok) return;
    const sessions = (await historyResponse.json()).sessions ?? [];
    const periods = periodResponse.ok ? (await periodResponse.json()).periods ?? {} : {};
    cards.forEach((card, index) => {
      const session = sessions[index];
      if (!session) return;
      card.dataset.sessionId = session.id;
      const summaryFirst = card.querySelector<HTMLElement>("summary > div:first-child");
      if (summaryFirst && !summaryFirst.querySelector(".qcm-history-period")) {
        const period = document.createElement("small");
        period.className = "qcm-history-period";
        period.textContent = `Période ${Number(periods[session.id] ?? 1)}`;
        summaryFirst.appendChild(period);
      }
      const summary = card.querySelector("summary");
      if (!summary || summary.querySelector(".qcm-history-delete")) return;
      const button = document.createElement("button");
      button.type = "button";
      button.className = "qcm-history-delete";
      button.textContent = "Supprimer";
      button.title = "Supprimer ce QCM et ses résultats";
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!window.confirm("Supprimer définitivement ce QCM, ses réponses et ses notes ?")) return;
        button.disabled = true;
        button.textContent = "Suppression…";
        const result = await nativeFetch(`/api/qcm-extra/sessions/${encodeURIComponent(session.id)}`, { method: "DELETE", credentials: "include" });
        if (!result.ok) {
          const body = await result.json().catch(() => ({}));
          window.alert(body.error ?? "Suppression impossible");
          button.disabled = false;
          button.textContent = "Supprimer";
          return;
        }
        card.remove();
        const refresh = [...document.querySelectorAll<HTMLButtonElement>(".qcm-results-page button")].find((item) => item.textContent?.includes("Actualiser"));
        refresh?.click();
      });
      summary.appendChild(button);
    });
  } catch { /* décoration non bloquante */ }
  finally { historySyncPending = false; }
}

const observer = new MutationObserver(() => {
  applyPeriodToSelect(currentPeriod());
  void decorateQcmHistory();
});
observer.observe(document.documentElement, { childList: true, subtree: true });

void hydratePeriod();
window.setTimeout(() => {
  applyPeriodToSelect(currentPeriod());
  void decorateQcmHistory();
}, 0);
